import type { CSSProperties } from 'react';
import styles from './Skeleton.module.css';

interface SkeletonProps {
    width?: string | number;
    height?: string | number;
    variant?: 'text' | 'title' | 'rounded' | 'card';
    className?: string;
    style?: CSSProperties;
}

export function Skeleton({ width, height, variant, className, style }: SkeletonProps) {
    const classes = [
        styles.bone,
        variant ? styles[variant] : '',
        className || '',
    ].filter(Boolean).join(' ');

    return (
        <div
            className={classes}
            style={{ width, height, ...style }}
        />
    );
}
